<h2 mat-dialog-title>{{data.title}}</h2>

<div class="top-panel">
    <div>Select destination {{calibrationSetCombinedTypeStr}}</div>
</div>

<mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>{{calibrationSetCombinedTypeStr}}</mat-label>
    <mat-select [formControl]="destinations" multiple>
        <mat-option *ngFor="let calibrationSet of calibrationSets" [value]="calibrationSet.Id">{{calibrationSet.Name}}
        </mat-option>
    </mat-select>
</mat-form-field>

<div class="popup-footer">
    <div class="attributes-button-container">
        <button class="button action button-with-icon" (click)="cloneUses()" [disabled]="!canClone">
            Clone</button>
        <button mat-dialog-close class="button">Cancel</button>
    </div>
</div>
